/* eslint-disable jsx-a11y/anchor-is-valid */
import { useNavigate } from "react-router-dom";
import { Button, IconButton, MenuItem, Select } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";
import StorageOutlinedIcon from "@mui/icons-material/StorageOutlined";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";

import { useState } from "react";
import SearchBar from "../../../components/SearchBar";
import AddDPA from "../../../Modals/addDPA";

const DataProcessing = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const policies = [
        {
            title: "Amazon Web Services",
            code: "DPA-001",
            description: "Cloud infrastructure hosting agreement",
            owner: "AWS",
            version: "Data Processor",
            effective: "1/1/2024",
            status: "Active",
            review: "Expires: 1/1/2027",
            icon: <StorageOutlinedIcon />
        },
        {
            title: "Stripe",
            code: "DPA-002",
            description: "Payment processing agreement",
            owner: "Stripe",
            version: "Data Processor",
            effective: "1/1/2024",
            status: "Active",
            review: "Expires: 1/1/2026",
            icon: <BusinessOutlinedIcon />
        },
        {
            title: "Twilio",
            code: "DPA-003",
            description: "Communication services agreement",
            owner: "Twilio",
            version: "Data Processor",
            effective: "2/15/2024",
            status: "Active",
            review: "Expires: 2/15/2026",
            icon: <GroupOutlinedIcon />
        }
    ];

    const [openModal, setOpenModal] = useState(false);
    const handleCloseModal = () => {
        setOpenModal(false);
    };
    return (
        <>
            {/* ===== Page Title ===== */}
            <div className="main_title d_flex">
                <div className="left_s">
                    <h1>Data Processing</h1>
                </div>

                <div className="right_s">
                    <Button
                        className="btn btn_primary"
                        onClick={() => setOpenModal(true)}
                    >
                        <AddIcon /> New DPA
                    </Button>
                </div>
            </div>

            {/* ===== Stats Overview (KEEP YOUR DESIGN) ===== */}

            {/* ======= Stats Overview ======= */}
            <div className="stats_boxes gap_m">

                {/* Total DPAs */}
                <a className="cards compact">
                    <div className="data_top">
                        <figure className="blue">
                            <DescriptionOutlinedIcon />
                        </figure>

                        <div className="meta">
                            <h2>6</h2>
                            <p>Total DPAs</p>
                        </div>
                    </div>
                </a>

                {/* Active */}
                <a className="cards compact">
                    <div className="data_top">
                        <figure className="sucess">
                            <VerifiedOutlinedIcon />
                        </figure>

                        <div className="meta">
                            <h2>5</h2>
                            <p>Active</p>
                        </div>
                    </div>
                </a>

                {/* Processors */}
                <a className="cards compact">
                    <div className="data_top">
                        <figure className="warning">
                            <StorageOutlinedIcon />
                        </figure>

                        <div className="meta">
                            <h2>5</h2>
                            <p>Processors</p>
                        </div>
                    </div>
                </a>

                {/* Sub-processors */}
                <a className="cards compact">
                    <div className="data_top">
                        <figure className="sucess">
                            <GroupOutlinedIcon />
                        </figure>

                        <div className="meta">
                            <h2>3</h2>
                            <p>Sub-processors</p>
                        </div>
                    </div>
                </a>

            </div>

            {/* ===== Search Header (AS REQUESTED) ===== */}
            <div className="cards mt_20">
                <div className="table_header">
                    <div className="left_s">
                        <SearchBar
                            searchTerm={searchTerm}
                            setDebouncedSearchTerm={setSearchTerm}
                            placeholder="Search policies..."
                        />
                    </div>

                    <div className="right_s form">
                        <Select size="small" value="All">
                            <MenuItem value="All">All Status</MenuItem>
                            <MenuItem value="Active">Active</MenuItem>
                            <MenuItem value="Review">Under Review</MenuItem>
                        </Select>
                    </div>
                </div>

                {/* ===== Policy List ===== */}
                <div className="policies_div mt_20">
                    {policies.map((policy, i) => (
                        <div className="policy_row" key={i}>
                            <div className="left">
                                <div className="policy_icon">
                                    {policy.icon}
                                </div>

                                <div className="policy_info">
                                    <div className="title_row">
                                        <b>{policy.title}</b>
                                        <span className="code">{policy.code}</span>

                                        <span className="status_chip active">
                                            {policy.status}
                                        </span>

                                        <span className="status_chip danger">
                                            {policy.review}
                                        </span>
                                    </div>

                                    <p>{policy.description}</p>

                                    <small>
                                        {policy.owner} · {policy.version} · Effective: {policy.effective}
                                    </small>
                                </div>
                            </div>

                            <div className="actions">

                                <IconButton onClick={() => setOpenModal(true)}><EditOutlinedIcon /></IconButton>
                                <IconButton><DeleteOutlineOutlinedIcon /></IconButton>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <AddDPA
                open={openModal}
                onClose={handleCloseModal}
                setOpen={setOpenModal}
            />
        </>
    );
};

export default DataProcessing;
